export default __webpack_public_path__ + "static/media/requiment-login-logo.71f6db01.svg";